import { create } from 'zustand';

interface SaasParams {
  maintenanceModeFront: boolean;
  maintenanceModeAdmin: boolean;
  openRegister: boolean;
  openCompetitionRegistration: boolean;
  referralEnabled: boolean;
  playerPlusEnabled: boolean;
  maintenanceMessage: string | null;
}

interface SaasStore extends SaasParams {
  loaded: boolean;
  setParams: (params: SaasParams) => void;
}

export const useSaasStore = create<SaasStore>()(set => ({
  maintenanceModeFront: false,
  maintenanceModeAdmin: false,
  openRegister: true,
  openCompetitionRegistration: true,
  referralEnabled: true,
  playerPlusEnabled: false,
  maintenanceMessage: null,
  loaded: false,

  setParams: params =>
    set({
      ...params,
      loaded: true,
    }),
}));
